<template>
  <v-list v-if="grouped" class="px-2">
    <div v-for="(group, time) in groupedNotes" class="note-group">
        <div class="note-group-header primary--text py-1" @click="jump(time)" @keyup.enter="jump(time)" tabindex="0"  :aria-label="formatedDuration(time) + ' Click to jump to note group time'" role="button">{{formatedDuration(time)}}</div>
        <note v-for="note in group" :key="note.id" :note="note" :editable="false" :canSeek="false"></note>
      </div>
    </div>
  </v-list>
  <v-list v-else class="px-2">
    <note v-for="note in notes" :note='note' :editable="false" :canSeek="false" :key="note.id"></note>
  </v-list>

</template>

<script>
/* global _ */
/* global moment */
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import EventBus from '@/buses/EventBus';
import _ from 'lodash';

import Note from './Note';

export default {
  name: 'NotesList',
  components: {
    Note,
  },
  props: [
    'notes',
    'grouped',
  ],
  data() {
    return {

    }
  },
  computed: {
    ...mapState('player', [
      'formatedDuration',
    ]),
    groupedNotes () {
      const groups = {}
      const prev = -1;
      this.notes.forEach(note => {
        const intTime = parseInt(note.displayTime);
        if (groups[intTime]) {
          groups[intTime].push(note);
        } else if (intTime >= prev + 1) {
          groups[intTime] = [note];
        }
      });
      return groups;
    }
  },
  methods: {
    ...mapMutations('player', [
      'setDesiredState'
    ]),
    jump(displayTime) {
      this.setDesiredState('pause');
      EventBus.$emit('requestAction', {
        key: 'seek',
        seekTime: displayTime,
        bypassGates: ['notWithinBounds', 'alreadySeeking']
      });
    },
  },
  watch: {

  },
  mounted() {

  },
};
</script>

<style>
  .note-group-header{
    float: left;
  }
  .note-group .discussion-comment {
    margin-left: 40px;
    width: calc(100% - 40px) !important;
    margin-bottom: 0px;
  }
</style>
